import { CSSProperties, FC } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { SvgIcon } from '@/components';
import { useOpenChat } from '@/hooks';

import styles from './PricingOnRequest.module.sass';

interface PricingOnRequestProps {
  /**
   * Accent color (used for CTA background).
   * Applied via the `--pricing-on-request-color` CSS variable, so any
   * descendant style can pick it up.
   */
  color?: string;
  className?: string;
}

const PricingOnRequest: FC<PricingOnRequestProps> = ({ color, className }) => {
  const { handleOpenChat } = useOpenChat();
  const { t } = useTranslation();

  return (
    <div
      className={cx(styles.root, className)}
      style={
        color
          ? ({ '--pricing-on-request-color': color } as CSSProperties)
          : undefined
      }
    >
      <div className={styles.title}>
        {t('translation.pricing_on_request_title')}
      </div>
      <div className={styles.body}>
        {t('translation.pricing_on_request_body')}
      </div>
      <button type="button" className={styles.cta} onClick={handleOpenChat}>
        <SvgIcon name="telegram" className={styles.ctaIcon} />
        {t('translation.pricing_on_request_cta')}
      </button>
      <div className={styles.footnote}>
        {t('translation.pricing_on_request_footnote')}
      </div>
    </div>
  );
};

export default PricingOnRequest;
